/* Issue #1 — Click PDP star-rating to scroll to Okendo reviews widget. */
(function () {
  'use strict';

  /*
   * Okendo renders the buy-box star-rating block with a variety of markups depending on
   * widget version and review count. Try them all; first match wins.
   */
  var STAR_SELECTORS = [
    // Star rating app block (buy box)
    '[data-oke-star-rating]',
    '.okeSR',
    '.okeSR-wrapper',
    '[data-oke-metafield-product-listing]',
    // Review summary inside hydrated reviews widget (used on PDPs with reviews)
    '.okeReviews-reviewsSummary.is-okeReviews-clickable',
    '.okeReviews-reviewsSummary',
    '.okeReviews-reviewsSummary-starRating'
  ];
  var REVIEWS_SELECTORS = [
    '[data-oke-reviews-widget]',
    '.okeReviews-reviewsWidget',
    '.okeReviews-widget-holder',
    '[data-oke-reviews-product-listing]',
    '.okeReviews',
    '[id^="oke-reviews-"]'
  ];

  function findFirst(selectors, root) {
    root = root || document;
    for (var i = 0; i < selectors.length; i++) {
      var el = root.querySelector(selectors[i]);
      if (el) return el;
    }
    return null;
  }

  function scrollToReviews() {
    var target = findFirst(REVIEWS_SELECTORS);
    if (!target) return;
    var headerOffset = 80;
    var rect = target.getBoundingClientRect();
    var y = rect.top + window.pageYOffset - headerOffset;
    window.scrollTo({ top: y, behavior: 'smooth' });
  }

  function wireStarRating() {
    var star = findFirst(STAR_SELECTORS);
    if (!star || star.dataset.reviewScrollWired === '1') return false;
    star.dataset.reviewScrollWired = '1';
    star.setAttribute('role', 'button');
    star.setAttribute('tabindex', '0');
    star.setAttribute('aria-label', 'See reviews');
    star.classList.add('js-rating-scroll');
    star.addEventListener('click', function (e) {
      e.preventDefault();
      scrollToReviews();
    });
    star.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        scrollToReviews();
      }
    });
    return true;
  }

  /*
   * Issue #1 follow-up — Figma spec shows `★★★★★ 4.9 | 980 Reviews`. Okendo's
   * admin exposes "Average Rating and Review Count" on the Star Ratings widget
   * but the element rendering on the PDP buy-box is actually from the Reviews
   * Widget's internal summary component, which doesn't honor that setting.
   *
   * Fix: prepend `<num> | ` to the visible count span client-side, using
   * window.okendoProductReviewAverageValue (Okendo emits this global on every
   * PDP with reviews). Skip gracefully on 0-review products — Okendo hides the
   * summary there anyway.
   */
  function injectNumericRating() {
    var avg = window.okendoProductReviewAverageValue;
    if (!avg || avg === 'null' || String(avg).toLowerCase() === 'null') return false;
    var count = document.querySelector('.okeReviews-reviewsSummary-ratingCount');
    if (!count || count.dataset.smRatingInjected === '1') return false;
    var visible = count.querySelector('span[aria-hidden="true"]');
    if (!visible) return false;
    var avgNode = document.createElement('span');
    avgNode.className = 'sm-oke-avg';
    avgNode.setAttribute('aria-hidden', 'true');
    avgNode.textContent = String(avg);
    var sepNode = document.createElement('span');
    sepNode.className = 'sm-oke-sep';
    sepNode.setAttribute('aria-hidden', 'true');
    sepNode.textContent = ' | ';
    visible.parentNode.insertBefore(sepNode, visible);
    visible.parentNode.insertBefore(avgNode, sepNode);
    count.dataset.smRatingInjected = '1';
    return true;
  }

  function init() {
    var wiredStar = wireStarRating();
    var injectedRating = injectNumericRating();
    if (wiredStar && injectedRating) return;
    var observer = new MutationObserver(function () {
      var a = wiredStar || wireStarRating();
      var b = injectedRating || injectNumericRating();
      if (a && b) observer.disconnect();
      wiredStar = a;
      injectedRating = b;
    });
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { observer.disconnect(); }, 15000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
